
































import { snakeCase } from 'lodash'
import { Component, Emit, Prop } from 'vue-property-decorator'

import CreateNewProperty from '../../../../../../../../../../BotProperties/components/Properties/CreateNewProperty.vue'
import { PropertyFieldType } from '../../../../../../../../../../BotProperties/components/Properties/types'
import { getNewPropertyIcon } from '../../../../../../../../../../BotProperties/utils'
import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../Pi/types'
import { ActionTypes } from '../../../../logic/Actions/types'
import { ActionNodeProps } from '../../../../logic/types'

@Component({
  components: {
    CreateNewProperty,
  },
  data() {
    return {
      snakeCase,
      ActionTypes,
    }
  }
})
export default class PropertyActionSelectProperty extends UseFields {
  @Prop() propertyIndex!: number | null

  @Prop() getProperties!: ActionNodeProps['getProperties']

  @Prop() createNewProperty!: (name: string, type: PropertyFieldType) => Promise<number>

  newPropertyName = ''

  isOpen = false

  get context(): this {
    return this
  }

  get properties(): Array<SelectOptionData> {
    return this.getProperties()
      .filter(p => !p?.readOnly && !p?.automatic)
      .map(({ name, id, type }) => {
      return {
        label: name ?? type,
        value: id,
        icon: {
          name: getNewPropertyIcon(type),
          iconPack: 'material-icons',
        }
      }
    })
  }

  setIndex(arg: FieldData): FieldData {
    arg.setter = (val) => this.setPropertyIndex(val)
    return arg
  }

  createNewPropertyHandler({ label }: SelectOptionData): void {
    this.newPropertyName = label
    this.isOpen = true
  }

  @Emit()
  setPropertyIndex(index: number): number {
    return index
  }
}
